// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay_overlay__20ZQd","hiddenOverlay":"overlay_hiddenOverlay__2sQ7I","overlayContent":"overlay_overlayContent__1scVE"};